module.exports = __webpack_public_path__ + "static/img/sm_program.f731443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone/page/sm_program.png
// module id = XODY
// module chunks = 1